import { memo } from "react";
import clsx from "clsx";
import { Outlet, useLocation } from "react-router";

import { RouteAnimation } from "../ui/RouteAnimation";
import { PAGE_LAYOUT_ID } from "@/features/notes/config";
import { useBoundStore } from "@/app/store";

export const MainDesktop = memo(() => {
  const location = useLocation();

  // Atomic selectors for layout config (not UI slots)
  const className = useBoundStore((state) => state.pageLayout.className);
  const showBottomNavigation = useBoundStore((state) => state.pageLayout.showBottomNavigation);
  const onScroll = useBoundStore((state) => state.pageLayout.onScroll);
  const animationKey = useBoundStore((state) => state.pageLayout.animationKey);

  const finalAnimationKey = animationKey || location.pathname;

  return (
    <RouteAnimation
      id={PAGE_LAYOUT_ID}
      animationKey={finalAnimationKey}
      className={clsx("relative flex-1 overflow-y-auto p-4 pt-1", className, {
        "pb-20": showBottomNavigation,
      })}
      onScroll={onScroll}
    >
      <Outlet />
    </RouteAnimation>
  );
});
MainDesktop.displayName = "MainDesktop";
